var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute top-0 z-50 w-full h-full flex items-center justify-center"},[_c('div',{staticClass:"w-full h-full bg-gray-500 opacity-60"}),_c('div',{staticClass:"absolute m-auto text-white"},[_c('loadingFlask'),_c('div',{staticClass:"text-center text-3xl font-bold"},[_vm._v("Loading...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }